export default __webpack_public_path__ + "static/media/plus.14b65891.svg";